var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpertaArt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 85.92 27.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00548b;}.cls-2{fill:#026937;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "16.52 0.48 12.19 0.48 16.01 7.54 18.33 3.87 16.52 0.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "20.88 16.55 25.08 16.55 21.1 9.1 18.79 12.69 20.88 16.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "21.45 0.49 18.91 4.5 16.6 8.17 9.1 20.07 9.1 26.06 18.45 11.57 20.77 7.98 25.6 0.49 21.45 0.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.39,18a4.87,4.87,0,0,1,1.25.15,2.71,2.71,0,0,1,.95.46,1.91,1.91,0,0,1,.6.82,3.12,3.12,0,0,1,.19,1.2,2.47,2.47,0,0,1-.2.91,3.92,3.92,0,0,1-.45.75,3.87,3.87,0,0,1-.56.58,4.59,4.59,0,0,1-.52.4l1.88,4.11h-2.6l-1.31-3.22H24.49l-.44,3.22h-2.3L23.2,18Zm-1.66,4.49h1.5a2.39,2.39,0,0,0,.44-.53,2.24,2.24,0,0,0,.31-.9,1.17,1.17,0,0,0-.24-1,1.12,1.12,0,0,0-.87-.33l-.45,0-.3.07Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "37.47 19.78 34.99 19.78 33.83 27.41 31.53 27.41 32.69 19.78 30.18 19.78 30.41 18.04 37.71 18.04 37.47 19.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "10.14 12.68 9.76 15.57 0 15.57 2.18 0 11.12 0 10.74 2.89 5.63 2.89 5.14 6.25 10.16 6.25 9.76 9.14 4.74 9.14 4.23 12.68 10.14 12.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33,0a6,6,0,0,1,4.12,1.3A4.36,4.36,0,0,1,38.47,5a5,5,0,0,1-.64,2.28,5.22,5.22,0,0,1-1.44,1.62,6.21,6.21,0,0,1-2,.95,8.84,8.84,0,0,1-2.36.31c-.21,0-.46,0-.75,0l-.74,0-.78,5.49H25.92L28.08,0ZM30.91,7.18a4.35,4.35,0,0,0,.65.06h.59a2.66,2.66,0,0,0,1.68-.53A2.27,2.27,0,0,0,34.6,5a2.09,2.09,0,0,0-.45-1.53,1.93,1.93,0,0,0-1.58-.62,3.8,3.8,0,0,0-.62,0L31.51,3Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "48.38 12.68 48 15.57 38.24 15.57 40.42 0 49.36 0 48.98 2.89 43.87 2.89 43.38 6.25 48.4 6.25 48 9.14 42.98 9.14 42.46 12.68 48.38 12.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M56.48,0a7.94,7.94,0,0,1,2.07.25A4.2,4.2,0,0,1,60.14,1a3.36,3.36,0,0,1,1,1.36,5.24,5.24,0,0,1,.31,2,3.93,3.93,0,0,1-.34,1.51,6.15,6.15,0,0,1-.74,1.25,6.62,6.62,0,0,1-.93,1,8.45,8.45,0,0,1-.86.65l3.11,6.83H57.37l-2.18-5.34H53.32l-.73,5.34H48.76L50.94,0ZM53.72,7.45h2.49a3.48,3.48,0,0,0,.72-.89,3.58,3.58,0,0,0,.53-1.49,2,2,0,0,0-.4-1.62,1.88,1.88,0,0,0-1.45-.56,4.86,4.86,0,0,0-.74,0,2.36,2.36,0,0,0-.5.11Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "74.3 2.89 70.19 2.89 68.41 15.57 64.58 15.57 66.37 2.89 62.18 2.89 62.58 0 74.7 0 74.3 2.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M81,11.57H75.82l-2,4H70.06L78.31,0h3.9l3.71,15.57h-4ZM77.14,8.85h3.2l-1-4.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.72,24.9H15.09l-1.43,2.41H11.4l6-9.37h1.78l2.18,9.37h-2.2Zm-2.64-1.63h2.37l-.63-2.94Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpertaArt);
export default __webpack_public_path__ + "static/media/Experta_ART.dd804696eaeef503ac6cbd0558da97fd.svg";
export { ForwardRef as ReactComponent };